<template>
  <span>
  <button
    type="button"
    class="btn btn-outline-primary"
    @click="showEmpCreateModal"
    v-if="user && user.type=='MANAGER'"
  >
    {{ labelBtn }}
  </button >
    <!-- create employee modal -->
    <createEmployeeModal ref="modal" :key="uniqueKey"></createEmployeeModal>
  </span>
</template>
<script>
import Swal from "sweetalert2";
import createEmployeeModal  from "../Employees/createEmployeeModal";
export default {
  name: "createEmployeeBtn",
  components: {
    createEmployeeModal
  },
  props:['labelBtn','uniqueKey'],
  data() {
    return {
      isCompanyMembership: true,
      companyMembership: {},
      isReferBY: (this.$store.getters.getUser.refer_by !='') ? true: false,
    }
  },
  created() {
    this.getCompany();
  },
  computed:{
    user() {
    return this.$store.state.user;
  },
  },
  methods: {
    getCompany() {
      this.id = this.$store.getters.getSelectedCompany.id;
      this.$axios.get(this.$GetCompany.replace(":id", this.id), {
        headers: this.getAuthHeader(),
      }).then((response) => {

        if( response.data.result.company.membership==='' || response.data.result.company.membership===null){
          this.isCompanyMembership=false;
        }else{
          this.companyMembership=response.data.result.company.membership;
        }
      })
    },
    showEmpCreateModal() {
      if(this.isCompanyMembership===true || this.isReferBY===true || this.$store.getters.getSelectedCompany.partner_customer_no !=''){
        let element = this.$refs.modal.$el
        $(element).modal('show')
        this.$root.$emit("refreshJobRoles");
      }else{
        new Swal({
          title: "Info",
          icon: "warning",
          text: "Please upgrade your plan",
          type: "info",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok!"
        }).then((result) => {
          if (result.value) {
            this.$router.push('/upgrade-plan');
          }})
      }
    },
  }
};
</script>

